import { Box, Button, Chip, Typography } from '@mui/material';
import React, { useState } from 'react'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom';
import { useManageState } from './manageStateDetail';
import { routeName } from '../../../../routes/routeName';
import { useNavigate, useParams } from 'react-router-dom';
import ContainerButton from '../../../../components/button/ContainerButton';
import StateComponents from '../../../../components/state-component/StateComponents';
import EditNoteIcon from '@mui/icons-material/EditNote';
import UploadAllFile from '../../components/UploadAllFile';
import ModalCustom from '../../../../components/modal/modalCustomCms';
import { debouncedApiCall } from '../../../../utils/app.utils';
import { ELibraryCategory, FILE_TYPE_DATA, head_status_data, header_detail, language_library_data, STATUS_E_LIBRARY } from '../../enum/elibrary_enum';
import { useTranslation } from 'react-i18next';
import { produce } from 'immer';

type Props = {
    view: boolean;
    library_category_name: string;
    menu_name?: string;
    menu_path_name?: string;
    menu_name_detail?: string;
    menu_name_detail_edit?: string;
}


const ManageBooksDetail: React.FC<Props> = ({
    menu_name = "จัดการหนังสือ",
    menu_path_name = routeName.e_library.manage_books,
    menu_name_detail = "เพิ่มหนังสือ",
    menu_name_detail_edit = "รายละเอียดหนังสือ",
    view,
    library_category_name }: Props) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const header_data = header_detail(t).find((x) => x.key === library_category_name)
    const category = library_category_name as ELibraryCategory
    const {
        pathname,
        cover_file,
        set_cover_file,
        example_book,
        set_example_book,
        handleCloseModal,
        show_modal,
        set_show_modal,
        NUM_TYPE_MODAL,
        set_qty_for_sale,
        set_qty_for_rent,
        qty_for_sale,
        handleChangeQty,
        handleSubmitQty,
        formState,
        library_type,
        set_search_library_type,
        qty_for_rent,
        id_library_type,
        set_id_library_type,
        id_library_author,
        set_id_library_author,
        set_search_library_author,
        library_author,
        publisher,
        set_id_publisher,
        set_search_publisher,
        id_publisher,
        handleSubmitForm,
        handleChangeFormState,
        price_amount,
        set_price_amount,
        document_category_type,
        complete_book,
        set_complete_book,
        podcast_file,
        set_podcast_file,
        set_document_category_type,
        status,
        makeEmptyItems,
        qtyCount,
        qty_for_sale_api,
        set_video_file,
        video_file,
        video_link,
        set_video_link
    } = useManageState({ library_category_name });

    const is_sale = (show_modal === NUM_TYPE_MODAL.FOR_SALE)

    // console.log(video_file, 'video_file')
    const [flag_api, set_flag_api] = useState<boolean>(false);

    return (<>
        <Box>
            <section className='flex justify-between full gap-3 flex-col md:flex-row'>
                <article className='flex flex-col gap-4'>
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "A",
                                name: "จัดการข้อมูล E-Library",
                                pathName: "",
                                disabled_match: true
                            },
                            {
                                key: "B",
                                name: menu_name,
                                pathName: menu_path_name,
                            },
                            ...(id ? [
                                {
                                    key: "C",
                                    name: menu_name_detail_edit,
                                    pathName: pathname,
                                },
                            ] : [
                                {
                                    key: "C",
                                    name: menu_name_detail,
                                    pathName: pathname,
                                },
                            ])
                        ]}
                    />
                    <Typography variant='h3'>
                        {id ? menu_name_detail_edit : menu_name_detail}
                    </Typography>
                </article>
                <article>
                    <ContainerButton
                        buttonData={[
                            {
                                buttonProps: {
                                    onClick: () => {
                                        if (window.history.length > 0) {
                                            navigate(-1);
                                        } else {
                                            navigate(routeName.e_library.manage_books);
                                        }
                                    }
                                },
                                key: "BACK",
                                label: "ยกเลิก",
                                seq: 1,
                                type: "BACK"
                            },
                            {
                                hidden: view,
                                buttonProps: {
                                    onClick: () => handleSubmitForm("DRAFT")
                                },
                                key: "SAVE_DRAFT",
                                label: status === STATUS_E_LIBRARY.DRAFT ? "บันทึกร่าง" : "ยกเลิกเผยแพร่",
                                seq: 2,
                                type: "SAVE_DRAFT"
                            },
                            {
                                hidden: view,
                                buttonProps: {
                                    onClick: () => handleSubmitForm("SUBMIT")
                                },
                                key: "CONFIRM",
                                label: "ยืนยัน",
                                seq: 3,
                                type: "CONFIRM"
                            },
                        ]}
                    />
                </article>
            </section>

            <Box className='grid grid-cols-12 mt-10 gap-8' component={'section'}>
                <article className='col-span-12 md:col-span-8'>
                    <StateComponents
                        disabledAllField={view}
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                fieldProps: {
                                    heading: header_data?.header_name,
                                    placeholder: header_data?.specify_header_name,
                                    value: formState.library_head_name,
                                    onChange: (e) => handleChangeFormState('library_head_name', e.target.value)
                                },
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12
                                }
                            },
                            {
                                seq: 2,
                                fieldProps: {
                                    getOptionLabel: (op) => op?.library_type_name || "",
                                    labelId: "121",
                                    options: library_type || [],
                                    value: id_library_type || null,
                                    limitTags: 1000,
                                    multiple: true,
                                    disableCloseOnSelect: true,
                                    placeholder: id_library_type?.length === 0 ? "ระบุหมวดหมู่" : undefined,
                                    isOptionEqualToValue: (option: any, value: any) => option.id_library_type === value.id_library_type,
                                    renderTags: (value: any[], getTagProps: any) => {
                                        return value?.map((option, index) => (
                                            <Chip
                                                variant="outlined"
                                                label={option?.library_type_name}
                                                {...getTagProps({ index })}
                                            />
                                        ))
                                    },
                                    onInputChange: (_: any, val: string) => debouncedApiCall({ searchItem: val, setItem: set_search_library_type }),
                                    onChange: (_, val) => set_id_library_type(val ?? null),
                                    heading: "หมวดหมู่",
                                },
                                type: "AUTO-COMPLETE",
                                gridProps: {
                                    xs: 12
                                }
                            },
                            {
                                seq: 3,
                                fieldProps: {
                                    getOptionLabel: (op) => op?.library_author_name,
                                    labelId: "1ๅๅ/2",
                                    options: library_author || [],
                                    value: id_library_author || null,
                                    onChange: (_, val) => set_id_library_author(val ?? null),
                                    onInputChange: (_: any, val: string) => debouncedApiCall({ searchItem: val, setItem: set_search_library_author }),
                                    heading: "โดย",
                                    placeholder: "ระบุ"
                                },
                                type: "AUTO-COMPLETE",
                                gridProps: {
                                    xs: 12,
                                    md: [ELibraryCategory.VIDEO].includes(category) ? 6 : 3
                                }
                            },
                            {
                                seq: 3.1,
                                hidden: ![ELibraryCategory.VIDEO].includes(category),
                                fieldProps: {
                                    labelId: "12",
                                    options: language_library_data || [],
                                    value: formState.language,
                                    heading: "ภาษา",
                                    placeholder: "ระบุ",
                                    onChange: (e) => handleChangeFormState('language', e.target.value),
                                    selectId: "language",
                                },
                                type: "SELECT",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                }
                            },
                            {
                                seq: 4,
                                hidden: [ELibraryCategory.VIDEO].includes(category),
                                fieldProps: {
                                    getOptionLabel: (op) => op?.library_author_name,
                                    labelId: "13",
                                    options: publisher || [],
                                    value: id_publisher || null,
                                    onChange: (_, val) => set_id_publisher(val ?? null),
                                    onInputChange: (_: any, val: string) => debouncedApiCall({ searchItem: val, setItem: set_search_publisher }),
                                    heading: header_data?.header_position,
                                    placeholder: header_data?.specify_header_position
                                },
                                type: "AUTO-COMPLETE",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                }
                            },
                            {
                                seq: 5,
                                hidden: [ELibraryCategory.VIDEO].includes(category),
                                fieldProps: {
                                    mode: "full_number",
                                    heading: [ELibraryCategory.PODCAST, ELibraryCategory.AUDIO_BOOK].includes(category) ? "จำนวนตอน" : "จำนวนหน้า",
                                    placeholder: [ELibraryCategory.PODCAST, ELibraryCategory.AUDIO_BOOK].includes(category) ? "ระบุจำนวนตอน" : "ระบุจำนวนหน้า",
                                    value: formState.library_page?.toString(),
                                    onChange: (e) => handleChangeFormState('library_page', e.target.value || "")
                                },
                                type: "TEXT-MASK",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                }
                            },
                            {
                                seq: 6,
                                fieldProps: {
                                    getOptionLabel: (op) => op?.name || "",
                                    labelId: "1231",
                                    options: head_status_data.filter((x) => x.name) || [],
                                    value: head_status_data?.find((x) => x.value === formState.library_head_status) || null,
                                    onChange: (_, val) => handleChangeFormState('library_head_status', val?.value || ""),
                                    heading: "สถานะ",
                                    placeholder: "ระบุสถานะ"
                                },
                                type: "AUTO-COMPLETE",
                                gridProps: {
                                    xs: 12,
                                    md: 3
                                }
                            },
                            {
                                seq: 7,
                                fieldProps: {
                                    heading: "เรื่องย่อ",
                                    row: 5,
                                    maxLength: 500,
                                    enableCountMaxLength: true,
                                    multiline: true,
                                    disabledAutoComplete: true,
                                    disablePaddingMultiline: true,
                                    value: formState.library_category_desc,
                                    onChange: (e) => handleChangeFormState('library_category_desc', e.target.value),
                                    placeholder: "ระบุรายละเอียด"
                                },
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                }
                            },
                        ]}
                    />


                    {[ELibraryCategory.BOOK, ELibraryCategory.E_BOOK, ELibraryCategory.AUDIO_BOOK].includes(category) && (
                        <>
                            {![ELibraryCategory.AUDIO_BOOK].includes(category) && (
                                <Box className="grid grid-cols-12 mt-4 gap-4">

                                    <article style={{ display: 'flex' }} className='col-span-12 md:col-span-6 gap-4'>
                                        <StateComponents
                                            disabledAllField={view}
                                            heading='จำนวนจำหน่าย'
                                            sxContainer={{ width: "100%" }}
                                            otherProps={{ spacing: 2 }}
                                            typeProps={[
                                                {
                                                    seq: 1,
                                                    fieldProps: {
                                                        mode: "full_number",
                                                        heading: "จำนวน",
                                                        placeholder: "ระบุจำนวน",
                                                        onChange: (e) => {
                                                            if (qty_for_sale_api?.length === qty_for_sale?.length) {
                                                                set_flag_api(true);
                                                            }
                                                            if (flag_api) {
                                                                const raw = e.target.value ?? "";
                                                                const n = Number(raw);
                                                                if (!Number.isFinite(n) || n <= 0) {
                                                                    set_qty_for_sale([]);
                                                                    return;
                                                                }
                                                                const new_qty = Array.from({ length: n }, () => ({ library_detail_number: "" }));
                                                                set_qty_for_sale(new_qty);
                                                            }
                                                        },
                                                        value: `${qty_for_sale?.length || ""}`,
                                                    },
                                                    type: "TEXT-MASK",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 6
                                                    }
                                                },
                                                {
                                                    seq: 2,
                                                    fieldProps: {
                                                        mode: "amount",
                                                        value: price_amount,
                                                        heading: "ราคา (บาท)",
                                                        onChange: (e) => set_price_amount(e.target.value),
                                                        placeholder: "ระบุราคา (บาท)"
                                                    },
                                                    type: "TEXT-MASK",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 6
                                                    }
                                                },
                                            ]}
                                        />
                                        {!view && (
                                            <Box sx={{ width: "fit-content" }} className="flex w-100 justify-end items-end">
                                                <Button disabled={qtyCount?.length === 0} onClick={() => {
                                                    set_show_modal(NUM_TYPE_MODAL.FOR_SALE);
                                                }} sx={{ height: "44px", }} color='secondary' variant='contained'>
                                                    <EditNoteIcon />
                                                </Button>
                                            </Box>
                                        )}
                                    </article>
                                    <article className='col-span-12 md:col-span-6'>
                                        <StateComponents
                                            disabledAllField={view}
                                            heading='ระยะเวลาที่เปิดให้ชำระ'
                                            otherProps={{ spacing: 2 }}
                                            typeProps={[
                                                {
                                                    seq: 1,
                                                    fieldProps: {
                                                        mode: "full_number",
                                                        heading: "ภายใน (จำนวนวัน)",
                                                        placeholder: "ระบุจำนวนวัน",
                                                        value: formState.library_payment_day?.toString(),
                                                        onChange: (e) => handleChangeFormState('library_payment_day', e.target.value)
                                                    },
                                                    type: "TEXT-MASK",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 6
                                                    }
                                                },
                                                {
                                                    seq: 2,
                                                    fieldProps: {
                                                        mode: "full_number",
                                                        maxNumber: 23,
                                                        heading: "ภายใน (จำนวนชั่วโมง)",
                                                        placeholder: "ระบุจำนวนชั่วโมง",
                                                        value: formState.library_payment_hour?.toString(),
                                                        onChange: (e) => handleChangeFormState('library_payment_hour', e.target.value)
                                                    },
                                                    type: "TEXT-MASK",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 6
                                                    }
                                                },
                                            ]}
                                        />
                                    </article>
                                </Box>
                            )}
                            <Box className="grid grid-cols-12 mt-4 gap-4">
                                <article className='col-span-12 md:col-span-6 flex gap-4'>
                                    <StateComponents
                                        disabledAllField={view}
                                        heading='จำนวนให้ยืม'
                                        sxContainer={{
                                            width: "100%"
                                        }}
                                        otherProps={{ spacing: 2 }}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                fieldProps: {
                                                    heading: "จำนวน",
                                                    placeholder: "ระบุจำนวน",
                                                    value: `${qty_for_rent?.length || ""}`,
                                                    onChange: (e) => {
                                                        const value = Number(e.target.value || "0");
                                                        if (value > 0) {
                                                            const raw = e.target.value ?? "";
                                                            const n = Number(raw);
                                                            if (!Number.isFinite(n) || n <= 0) {
                                                                set_qty_for_rent([]);
                                                                return;
                                                            }
                                                            const new_qty = Array.from({ length: n }, () => ({ library_detail_number: "" }));
                                                            set_qty_for_rent(new_qty)
                                                        }
                                                    }
                                                },
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12,
                                                }
                                            },
                                        ]}
                                    />
                                    {!view && (
                                        <Box className="flex w-full max-w-fit justify-end items-end">
                                            <Button disabled={qty_for_rent?.length === 0} onClick={() => set_show_modal(NUM_TYPE_MODAL.FOR_LEND)} sx={{ height: "44px", }} color='secondary' variant='contained'>
                                                <EditNoteIcon />
                                            </Button>
                                        </Box>
                                    )}
                                </article>
                                <article className='col-span-12 md:col-span-6'>
                                    <StateComponents
                                        disabledAllField={view}
                                        heading='ระยะเวลาที่ให้ยืม'
                                        otherProps={{ spacing: 2 }}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                fieldProps: {
                                                    heading: "ภายใน (จำนวนวัน)",
                                                    placeholder: "ระบุจำนวนวัน",
                                                    value: formState.library_rent_day?.toString(),
                                                    onChange: (e) => handleChangeFormState('library_rent_day', e.target.value)
                                                },
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12,
                                                    md: 6
                                                }
                                            },
                                            {
                                                seq: 2,
                                                fieldProps: {
                                                    mode: "full_number",
                                                    maxNumber: 23,
                                                    heading: "ภายใน (จำนวนชั่วโมง)",
                                                    placeholder: "ระบุจำนวนชั่วโมง",
                                                    value: formState.library_rent_hour?.toString(),
                                                    onChange: (e) => handleChangeFormState('library_rent_hour', e.target.value)
                                                },
                                                type: "TEXT-MASK",
                                                gridProps: {
                                                    xs: 12,
                                                    md: 6
                                                }
                                            },
                                        ]}
                                    />
                                </article>
                            </Box>
                        </>
                    )}
                </article>
                <article className='col-span-12 md:col-span-4'>
                    <UploadAllFile
                        heading="File"
                        view={view}
                        onDeleteRow={(globalIndex) => {
                            set_document_category_type(prev =>
                                prev.filter((_, i) => i !== globalIndex)
                            );
                            set_podcast_file(prev => {
                                if (!Array.isArray(prev)) return prev;
                                return prev.filter((_, i) => i !== globalIndex);
                            });
                        }}
                        onAddMore={() => {
                            const find_document_category_type =
                                document_category_type?.find(
                                    (x) => x.library_file_document === FILE_TYPE_DATA.POD_CAST
                                );
                            const find_document_category_type_audio_book =
                                document_category_type?.find(
                                    (x) => x.library_file_document === FILE_TYPE_DATA.AUDIO_BOOK
                                );
                            if (find_document_category_type) {
                                set_document_category_type((prev) => [
                                    ...prev,
                                    find_document_category_type,
                                ]);
                            }
                            if (find_document_category_type_audio_book) {
                                set_document_category_type((prev) => [
                                    ...prev,
                                    find_document_category_type_audio_book,
                                ]);
                            }
                        }}
                        onLinkChange={(link, base_index, file_index) => {
                            if (typeof base_index !== "number") return;
                            if (typeof file_index !== "number") return;

                            set_podcast_file(prev => {
                                const next = [...prev];
                                next[base_index] = { link_file: link };
                                return next;
                            });
                            if (link) {
                                const type =
                                    document_category_type?.[base_index]?.library_file_document as
                                    | FILE_TYPE_DATA
                                    | undefined;
                                if (!type) return;
                                if (type === FILE_TYPE_DATA.COVER_FILE) {
                                    set_cover_file(null);
                                } else if (type === FILE_TYPE_DATA.EXAMPLE_BOOK) {
                                    set_example_book(null);
                                } else if (type === FILE_TYPE_DATA.VIDEO_FILE) {
                                    set_video_link(link);
                                    set_video_file(null);
                                } else if ([FILE_TYPE_DATA.COMPLETE_BOOK, FILE_TYPE_DATA.COMPLETE_THE_SIS_FILE, FILE_TYPE_DATA.JOURNAL_FILE].includes(type)
                                ) {
                                    set_complete_book(null);
                                } else if ((type === FILE_TYPE_DATA.POD_CAST || type === FILE_TYPE_DATA.AUDIO_BOOK)) {
                                    set_podcast_file(prev => {
                                        const next = Array.isArray(prev) ? [...prev] : [];
                                        if (next[base_index]) next[base_index] = { ...next[base_index], file: null };
                                        return next;
                                    });
                                }
                                // else if (type === FILE_TYPE_DATA.VIDEO_FILE) {
                                //     set_podcast_file(prev => {
                                //         const next = Array.isArray(prev) ? [...prev] : [];
                                //         if (next[base_index]) next[base_index] = { ...next[base_index], file: null };
                                //         return next;
                                //     });
                                // }
                            }
                        }}
                        typeData={document_category_type?.map((list, idx) => {
                            const library_file_document = list?.library_file_document as FILE_TYPE_DATA;
                            const is_cover_file = library_file_document === FILE_TYPE_DATA.COVER_FILE;
                            const is_example_book = library_file_document === FILE_TYPE_DATA.EXAMPLE_BOOK;
                            const is_complete_book = [
                                FILE_TYPE_DATA.COMPLETE_BOOK,
                                FILE_TYPE_DATA.COMPLETE_THE_SIS_FILE,
                                FILE_TYPE_DATA.JOURNAL_FILE,
                            ].includes(library_file_document);
                            const is_podcast = library_file_document === FILE_TYPE_DATA.POD_CAST;
                            const is_audio_book = library_file_document === FILE_TYPE_DATA.AUDIO_BOOK;
                            const is_video = library_file_document === FILE_TYPE_DATA.VIDEO_FILE;
                            const allow_example_check = [FILE_TYPE_DATA.POD_CAST, FILE_TYPE_DATA.AUDIO_BOOK].includes(library_file_document)
                            const allow_image_type = is_cover_file;
                            const allow_pdf_type =
                                is_example_book ||
                                library_file_document === FILE_TYPE_DATA.COMPLETE_BOOK ||
                                library_file_document === FILE_TYPE_DATA.JOURNAL_FILE;
                            const allow_link: string[] = [FILE_TYPE_DATA.POD_CAST, FILE_TYPE_DATA.VIDEO_FILE, FILE_TYPE_DATA.AUDIO_BOOK];
                            return {
                                title: list?.library_file_document || "",
                                file: is_cover_file
                                    ? cover_file
                                    : is_example_book
                                        ? example_book
                                        : is_complete_book
                                            ? complete_book
                                            : is_video ? video_file : (is_podcast || is_audio_book)
                                                ? podcast_file[idx]?.file || null
                                                : null,
                                allow_link: allow_link.includes(library_file_document),
                                link_file: is_video ? video_link : podcast_file[idx]?.link_file,
                                checked_example: podcast_file[idx]?.checked_example,
                                onAllowExampleCheck: (checked_example, index) => {
                                    set_podcast_file(prev => {
                                        if (!Array.isArray(prev)) return prev;
                                        return prev.map((item, i) =>
                                            i === index ? { ...item, checked_example } : item
                                        );
                                    });
                                },
                                only_mp3: [FILE_TYPE_DATA.POD_CAST, FILE_TYPE_DATA.AUDIO_BOOK].includes(library_file_document),
                                only_mp4: [FILE_TYPE_DATA.VIDEO_FILE].includes(library_file_document),
                                onFileChange: (file) => {
                                    if (is_cover_file) set_cover_file(file || null);
                                    if (is_example_book) set_example_book(file || null);
                                    if (is_complete_book) set_complete_book(file || null);
                                    if (is_video) {
                                        set_video_file(file || null);
                                        set_video_link("");
                                    }
                                    if (is_podcast || is_audio_book) {
                                        set_podcast_file(prev => {
                                            const next = [...prev];
                                            next[idx] = { file: file || null, status: next[idx]?.status };
                                            return next;
                                        });
                                    }
                                },
                                onDeleteFile: () => {
                                    if (is_cover_file) set_cover_file(null);
                                    if (is_example_book) set_example_book(null);
                                    if (is_complete_book) set_complete_book(null);
                                    if (is_video) {
                                        set_video_link("");
                                        set_video_file(null);
                                    }
                                    if (is_podcast || is_audio_book) {
                                        set_podcast_file(prev => prev.filter((_, i) => i !== idx));
                                        // if (idx >= 1) {
                                        //     set_document_category_type((prev) => prev.filter((_, i) => i !== idx));
                                        // }
                                    }
                                },
                                allow_example_check: allow_example_check,
                                multiple: [FILE_TYPE_DATA.POD_CAST, FILE_TYPE_DATA.AUDIO_BOOK].includes(library_file_document),
                                allow_type: allow_image_type
                                    ? ["IMAGE"]
                                    : allow_pdf_type
                                        ? ["PDF"]
                                        : is_complete_book
                                            ? ["PDF"]
                                            : (is_podcast || is_audio_book)
                                                ? ["MP3"]
                                                : is_video ? ["MP4"] : [],
                                date: new Date(),
                                _originIndex: idx,
                            };
                        })}
                    />
                    {/*  */}
                </article>
            </Box>
        </Box>

        {[NUM_TYPE_MODAL.FOR_SALE, NUM_TYPE_MODAL.FOR_LEND].includes(show_modal) && (
            <ModalCustom
                handleClose={handleCloseModal}
                onClick={() => handleSubmitQty(is_sale ? 'sale' : 'rent')}
                scrollBody
                open
                title={is_sale ? 'ระบุเลขจำนวนจำหน่าย' : 'ระบุเลขเรียกหนังสือให้ยืม'}
                disabledSubmitButton={is_sale ? qty_for_sale?.some((x) => !x.library_detail_number) : qty_for_rent?.some((x) => !x.library_detail_number)}
                form={
                    <Box width={"100%"} my={2}>
                        {is_sale ? (
                            <StateComponents disabledAllField={view} otherProps={{ spacing: 2 }} typeProps={qty_for_sale?.map((list, i) => {
                                return {
                                    seq: i + 1,
                                    fieldProps: {
                                        required: true,
                                        heading: "รายการที่" + ` ${i + 1}`,
                                        value: list.library_detail_number,
                                        onChange: (e) => {
                                            handleChangeQty('sale', e.target.value, i)
                                        },
                                        placeholder: "ระบุจำนวนวัน"
                                    },
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                    }
                                }
                            })} />
                        ) : (
                            <StateComponents otherProps={{ spacing: 2 }} typeProps={qty_for_rent?.map((list, i) => {
                                return {
                                    seq: i + 1,
                                    fieldProps: {
                                        required: true,
                                        heading: "รายการที่" + ` ${i + 1}`,
                                        value: list.library_detail_number,
                                        onChange: (e) => handleChangeQty('rent', e.target.value, i),
                                        placeholder: "ระบุจำนวนวัน"
                                    },
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                    }
                                }
                            })} />
                        )}
                    </Box>
                }
            />
        )}
    </>
    )
}

export default ManageBooksDetail